import { defineElement, FC, onDidLoad, useElement, useProp } from '@atomify/hooks';
import { SLIDER_PROGRESS_CELL_CONTAINER, SliderProgressElement } from '@molecules/slider-progress';
import { userStore } from '@store/user';
import { partition } from '@utilities/partition';

const WishlistController: FC = () => {
    const [disabled] = useProp<boolean>('disabled', false);

    const sliderElement = useElement<SliderProgressElement>('bpd-slider-progress');
    const cellContainer = useElement<HTMLElement>(`[${SLIDER_PROGRESS_CELL_CONTAINER}]`);

    const isInWishlist = (cell: Element | null, wishlist: string[]) => {
        const constructionNumberId = cell
            ?.querySelector('bpd-wishlist-favourite-button')
            ?.getAttribute('construction-number-id');
        return constructionNumberId ? wishlist.includes(constructionNumberId) : false;
    };

    onDidLoad(async () => {
        const wishlist = userStore.getState().wishlist;
        if (disabled || !wishlist?.length) return;

        const { current: slider } = sliderElement;
        const { current: container } = cellContainer;
        if (!slider || !container) return;

        const [inWishlist = [], rest = []] = partition<Element>(
            Array.from(container.children),
            (cell) => isInWishlist(cell, wishlist),
        );
        const clonedSlides = [...inWishlist, ...rest].map((cell) => cell.cloneNode(true));

        container.innerHTML = '';
        clonedSlides.forEach((clone) => container.appendChild(clone));

        if (!slider.connected) await slider.componentOnReady();
        slider.reload();
    });
};

WishlistController.props = {
    disabled: {
        type: Boolean,
        reflectToAttr: true,
    },
};

defineElement('bpd-property-slider-wishlist-controller', WishlistController);
